module.exports = __webpack_public_path__ + "static/MobileHeartbeat Logo-18df8fd09e6944c7bbf3977c0b807337.png";